import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ViewDocIdDocumentModalComponent} from './view-doc-conserve-modal';

export const ViewDocIdConserveModalModule: string = ng
  .module('view-doc-conserve-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('viewDocIdDocumentModalComponent', ViewDocIdDocumentModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/view-doc-conserve-modal/view-doc-conserve-modal.module.ts